<template>
    <form
        id="personal-data"
        class="cabinet-settings supplier-tab hide"
        data-title="Личные данные"
        @submit.prevent="onUpdateUser()"
    >
        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label required" for="name"
                >Имя</label
            >
            <input
                id="name"
                v-model="name"
                type="text"
                class="cabinet-form-group__input"
                :class="{
                    error:
                        ($v.name.$dirty && $v.name.$invalid) ||
                        errors.updateUser.name
                }"
            />
            <div v-if="$v.name.$dirty && $v.name.$invalid" class="error-label">
                Поле необходимо заполнить
            </div>
            <div v-if="errors.updateUser.name" class="error-label">
                {{ errors.updateUser.name[0] }}
            </div>
        </div>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label required" for="email"
                >Электронная почта</label
            >
            <input
                id="email"
                v-model="email"
                type="email"
                class="cabinet-form-group__input"
                :class="{
                    error:
                        ($v.email.$dirty && $v.email.$invalid) ||
                        errors.updateUser.email
                }"
            />
            <div
                v-if="$v.email.$dirty && $v.email.$invalid"
                class="error-label"
            >
                Введите корректный email
            </div>
            <div v-if="errors.updateUser.email" class="error-label">
                {{ errors.updateUser.email[0] }}
            </div>
        </div>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label required" for="phone"
                >Телефон</label
            >
            <input
                id="phone"
                v-model="phone"
                type="phone"
                class="cabinet-form-group__input"
                :class="{
                    error:
                        ($v.phone.$dirty && $v.phone.$invalid) ||
                        errors.updateUser.phone
                }"
            />
            <div
                v-if="$v.phone.$dirty && $v.phone.$invalid"
                class="error-label"
            >
                Поле необходимо заполнить
            </div>
            <div v-if="errors.updateUser.phone" class="error-label">
                {{ errors.updateUser.phone[0] }}
            </div>
        </div>

        <div class="product-form__btn-wrap">
            <button
                type="submit"
                class="cabinet-btn product-form__btn"
                :class="{ loading: loading }"
                :disabled="loading"
            >
                Сохранить изменения
            </button>
        </div>
    </form>
</template>

<script>
import { required, email, maxLength } from 'vuelidate/lib/validators'

import { mapState, mapActions } from 'vuex'

export default {
    name: 'SupplierPersonalData',
    data() {
        return {
            name: '',
            email: '',
            phone: '',
            loading: false
        }
    },
    validations: {
        email: {
            required,
            //email,
            maxLength: maxLength(255)
        },
        name: { required },
        phone: { required }
    },
    computed: {
        ...mapState('user', ['user', 'errors'])
    },
    watch: {
        user: {
            handler: function(val) {
                this.setUserFields()
            },
            deep: true
        }
    },
    mounted() {
        this.setUserFields()
    },
    methods: {
        ...mapActions('user', ['updateUser']),
        setUserFields() {
            this.name = this.user ? this.user.name : ''
            this.email = this.user ? this.user.email : ''
            this.phone = this.user ? this.user.phone : ''
        },
        async onUpdateUser() {
            if (this.loading) return

            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.loading = true
                await this.updateUser({
                    email: this.email,
                    name: this.name,
                    phone: this.phone
                })
                this.loading = false
                this.$notify({
                    title: 'Профиль',
                    type: 'success',
                    text: 'Успешно обновлен'
                })
            } else {
                console.log('Form not valid')
            }
        }
    }
}
</script>
